'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline'
import { Carousel } from 'react-responsive-carousel'

const testimonialContent = [
  {
    text: "“Working with Craig has been an honor. As an experienced entrepreneur, he's been an invaluable mentor to our team. His incubator program and Robin's team provided expert guidance for our innovative Metaverse company. Lunique.io has greatly benefited from his talent for fostering startups.”",
    name: 'Annie Siara',
    work: 'CEO of Lunique.io',
    profile: '/testimonials/annie.webp',
  },
  {
    title: 'A consummate professional',
    text: '“Patrick is a consummate professional. Passionate, but level-headed and very good at conveying a message clearly and concisely.”',
    name: 'Kurt Wuckert Jr.',
    work: 'CEO of Gorilla Pool',
    profile: '/testimonials/kurt.webp',
  },
  {
    text: '“Robin is a tech genius with expertise in AI and blockchain. He knows how to build startups cheaply and efficiently, which is a valuable skill in the fast-paced world of tech. With Robin on your team, you can be sure that your company will be at the cutting edge of technology. His knowledge and experience in these fields make him an invaluable asset to any startup looking to make a name for itself.”',
    name: 'Michal Scislowski',
    work: 'CEO of Soundoshi',
    profile: 'https://i.ibb.co/XtLd7zh/Michal.png',
  },
  {
    text: '“Craig is a firework and his ability to break down the business into smaller financial pieces was remarkable, and he helped us understand the financial implications of our business model.”',
    name: 'Ole Andre Knutli',
    work: 'CEO of Coinsurvey',
    profile: 'https://i.ibb.co/G70D1Dh/ole-Coin-1.png',
  },
  {
    text: '“Craig is an experienced and energetic founder. His previous accelerator programme was pivotal to my success; from spending a whole day with me to build my financial model and investing personally in my company. With the advent of ChatGPT I think AI is the future of companies so I wholly support Craig in setting up the accelerator programme and encouraging early-stage start ups to succeed.”',
    name: 'Hannah Nicholson',
    work: 'CEO of MoveGenius',
    profile: './testimonials/hannah.webp',
  },
  {
    text: '“Craig and Robin make an A team. Their combination of finance, business and technology is key to helping businesses to succeed. The energy, business knowledge and experience, combined with top tech skills. Unbeatable!”',
    name: 'Borja Burguillos',
    work: 'CEO of 5tars',
    profile: 'https://i.ibb.co/vdNC1zG/borja.png',
  },
  {
    text: '“The team (Robin & Craig) building this program bring a wealth of practical industry experience, combined with real strategic and technical thinking. Between the financial support we were provided, and the capability to help our in-house development to build an MVP, we were ecstatic with the support we received. Highly recommend them!”',
    name: 'Tim Malik',
    work: 'CEO of Combat IQ',
    profile: '/testimonials/tim.webp',
  },

  {
    text: '“Joining AI forge is the best thing that could have happened for my business, its truly like doing an MBA in 12 week. I’ve learned more during this time than I have in the last 10 years working in business.”',
    name: 'Antonella Cossu',
    work: 'FilmTailor',
    profile:
      '/images/testimonials/antonella-cossu.png',
  },
  {
    text: '“The thing I love about AI Forge is in comparison to other incubators is the care, the personal care that they apply to you and your business. At the end of the day it is a business, but they truly care about founders succeeding, putting time and effort out of their personal lives to ensure we succeed.”',
    name: 'George Westbrook',
    work: 'Genie-iQ',
    profile:
      '/images/testimonials/george-westbrook.jpg',
  },
  {
    text: `“The eureka moment for me in the programme was when I got deep into the financial modeling. I've always been fine at pitching, and always had a deep passion for my subject matter, but understanding how to turn it into a business only really came to light when I got through many two hour spells trying to make my model match what I envisaged in growing my business.”`,
    name: 'Richard Lewis',
    work: 'BrainMan VR',
    profile:
      '/images/testimonials/richard-lewis.jpg',
  },
]

const Testimonial = () => {
  return (
    <div className="bg-black py-16 sm:py-24">
      <FadeInStagger className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <FadeIn>
          <div className="border border-[#424242] sm:rounded-3xl overflow-hidden">
            <Carousel
              showThumbs={false}
              // showArrows={true}
              showStatus={false}
              showIndicators={false}
              autoPlay
              infiniteLoop
              transitionTime={1500}
              interval={5000}
              renderArrowPrev={(clickHandler, hasPrev) => {
                return (
                  <div
                    className={`${
                      hasPrev ? 'absolute' : 'hidden'
                    } bottom-4 md:bottom-20 left-[10%] sm:left-[34%] flex justify-center items-center p-3 opacity-30 hover:opacity-100 cursor-pointer z-20`}
                    onClick={clickHandler}
                  >
                    <ArrowLeftIcon className="w-9 h-9 text-white" />
                  </div>
                )
              }}
              renderArrowNext={(clickHandler, hasNext) => {
                return (
                  <div
                    className={`${
                      hasNext ? 'absolute' : 'hidden'
                    } bottom-4 md:bottom-20 right-[10%] sm:right-[34%] flex justify-center items-center p-3 opacity-30 hover:opacity-100 cursor-pointer z-20`}
                    onClick={clickHandler}
                  >
                    <ArrowRightIcon className="w-9 h-9 text-white" />
                  </div>
                )
              }}
            >
              {testimonialContent.map((content, index) => (
                <div
                  className="relative overflow-hidden bg-black bg-gradient-to-br from-neutral-900 lg:h-[500px] to-black py-5 px-6 shadow-xl sm:rounded-3xl  sm:px-10 md:px-16 lg:px-16 min-h-full "
                  key={index}
                >
                  <div className="flex flex-col gap-8 items-center ">
                    <div className="relative">
                      <figure>
                        <div className="p-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
                          <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                            <p className="text-center text-white text-sm font-medium leading-[20px]">
                              Testimonial{' '}
                            </p>
                          </div>
                        </div>
                        <blockquote className="mt-6 text-lg font-medium text-white sm:text-[30px] sm:leading-[44px]">
                          <p>{content.text}</p>
                        </blockquote>
                        <div className="flex flex-col justify-center items-center ">
                          <div className="h-14 w-14 mt-8 bg-[#E0E0E0] rounded-full">
                            {content.profile ? (
                              <img
                                className="h-14 w-14 rounded-full"
                                src={content.profile}
                                alt=""
                                loading="lazy"
                              />
                            ) : (
                              <span className="flex w-14 h-14 min-w-14  items-center justify-center rounded-full bg-white">
                                <span className="text-xs text-black font-medium leading-none  uppercase">
                                  {content.name?.slice(0, 2)}
                                </span>
                              </span>
                            )}
                          </div>
                          <div className="flex-col justify-center items-center gap-1 flex">
                            <div className="text-center text-white text-base font-semibold leading-normal">
                              {content.name}
                            </div>
                            <div className="text-center text-gray-200 text-sm font-normal leading-tight">
                              {content.work}
                            </div>
                          </div>
                        </div>
                      </figure>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </FadeIn>
      </FadeInStagger>
    </div>
  )
}
export default Testimonial
